export const DEAFULT_ERROR_MESSAGE = 'This field is required';
export const EMAIL_FORMAT_ERROR = 'Entered value does not match email format';
export const FORGOT_PASSWORD_HEADER = 'Forgot password';
export const FORGOT_PASSWORD_BUTTON = 'Reset password';
export const BACK_TO_SIGNIN_BTN_TEXT = "Back to sign in";
export const FORGOT_PASSWORD_SUCCESSFUL_MESSAGE = 'Please check your email and follow instructions.';
